import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

type TUserCardDesktopBlockedChatProps = {
  handleClickSpam: () => void;
};

export const UserCardDesktopBlockedChat: React.VFC<TUserCardDesktopBlockedChatProps> = ({ handleClickSpam }) => {
  return (
    <button className={styles['text']} onClick={handleClickSpam} data-testid="UserCardDesktopBlockedChat">
      <UIText1>Заблокировать чат</UIText1>
    </button>
  );
};
